import { render, staticRenderFns } from "./NewEndorsement.vue?vue&type=template&id=46532411&scoped=true"
import script from "./NewEndorsement.vue?vue&type=script&lang=js"
export * from "./NewEndorsement.vue?vue&type=script&lang=js"
import style0 from "./NewEndorsement.vue?vue&type=style&index=0&id=46532411&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46532411",
  null
  
)

export default component.exports